module.exports = __webpack_public_path__ + "img/kryukov.677d0fbe.png";